import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div>
      {/*<h1>Welcome to Our Website</h1>*/}
      {/* Show PNG logo */}
      {/*<img src="/images/landscapeblack.png" alt="Company Logo" /> */}

      {/* Show animated GIF */}
      {/*<img src="/images/animation.gif" alt="Animated GIF" />*/}

      {/* Show banner */}
      <img src="/images/betaplaceholder.jpg" alt="Banner" style={{width: '100%'}} />
    </div>
  );
}

export default App;
